import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_751_66)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.18485 0C0.530475 0 0 0.553539 0 1.23637V23.1083C0 23.359 0.316359 23.4505 0.440097 23.2357L12.3529 2.54545L23.5568 23.1837C23.6769 23.4047 24 23.3159 24 23.0618V1.23637C24 0.553539 23.4695 0 22.8152 0H1.18485ZM6 24L12 7.99999L18 24H14.1176L12 13.8182L9.88235 24H6Z",
        fill: "#243B53"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_751_66" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }